<template>
  <div>
    <el-select 
      style="width: 100%" 
      clearable 
      :placeholder="$t('Seçin')"
      filterable 
      :value="selected === null ? '' : selected" 
      @input="handleInput" 
      :disabled="off"
    >
      <el-option label="Seçin" :value="null"></el-option>
      <el-option 
        v-for="item in data" 
        :key="item.id" 
        :label="item.name" 
        :value="item.id"
      ></el-option>
    </el-select>
  </div>
</template>

<script>
import { GetAccidentFinishReasons } from "../../services/cls";
export default {
  props: {
    value: [Number, String],
    disabled: Boolean,
  },
  data() {
    return {
      data: [],
      selected: this.value,
      off: this.disabled,
    };
  },
  methods: {
    handleInput(e) {
      this.$emit("input", e === '' ? null : e);
      this.selected = e === '' ? null : e;
    },
    getData() {
      GetAccidentFinishReasons().then((response) => {
        if (response.data.data) {
          this.data = response.data.data;
        } else {
          this.$message({
            type: "error",
            message: "Accident Finish Reasons: No data found!",
          });
        }
      });
    },
  },
  mounted() {
    this.getData();
  },
  watch: {
    value() {
      this.selected = this.value;
    },
    disabled() {
      this.off = this.disabled;
    },
  },
};
</script>